(() => {
  (function (__window, fetch) {
    const ADD_TO_CART_REGEX = /^(?:\/[a-zA-Z]+(?:-[a-zA-Z]+)?)?\/+cart\/+(change|add)(?:\.js|\.json)?\/*$/
    if (typeof fetch === "function") {
      __window.fetch = function () {
        return fetch.apply(this, Array.prototype.slice.call(arguments)).then(response => {
          if (!response.ok) {
            return response
          }
          const hyperlinkElement = document.createElement("a");
          hyperlinkElement.href = response.url;
          const path = hyperlinkElement.pathname ? hyperlinkElement.pathname : response.url;
          const isCartUpdate = path.includes("/change");
          try {
            if (ADD_TO_CART_REGEX.test(path)) {
              try {
                const requestPayload = arguments[1] || {}
                const requestPlacement = requestPayload.headers ? requestPayload.headers['site-placement'] : null
                const isGift = requestPayload.headers ? !!requestPayload.headers['sca_add_gift'] : false
                const requestBody = (() => {
                  if (requestPayload.headers && requestPayload.headers['add-to-cart-original-payload']) return requestPayload.headers['add-to-cart-original-payload']
                  return requestPayload.body || "{}"
                })()
                handleFetchAddToCart(response, requestBody, requestPlacement, isCartUpdate, isGift);
              } catch (error) {}
            }
          } catch (error) {
            consoleError(error)
          }
          return response
        })
      }
    }

    function handleFetchAddToCart(response, requestBody, requestPlacement, isCartUpdate, isGift) {
      response.clone().json().then(responseJson => {
        if (Object.prototype.toString.call(responseJson) !== "[object Object]") {
          return
        }
        if (responseJson.items) {
          const parsedPayloadBodyItemsList = parseRequestBody(requestBody).items;
          const parsedResponseItemsList = (() => {
            if (isCartUpdate) return responseJson.items_added
            return responseJson.items || []
          })()
          if (isCartUpdate && !parsedResponseItemsList.length) return // Produto foi removido do carrinho
          handleBulkItemCartAddResponse(parsedResponseItemsList, parsedPayloadBodyItemsList, requestPlacement, isGift);
          return
        }
        const quantity = parseSingleItemQuantity(requestBody);
        handleItemAdded(responseJson, quantity, requestPlacement, isGift)
      }).catch(consoleError)
    }

    function consoleError(error) {
      if (console && console.error) {
        console.error(`[add-to-cart-tracker] Error in handleFetchRequest:  ${error.message}`)
      }
    }
  })(window, window.fetch);

  function handleBulkItemCartAddResponse(parsedResponseItemsList, parsedPayloadBodyItemsList, requestPlacement, isGift) {
    if (parsedResponseItemsList.length !== parsedPayloadBodyItemsList.length) {
      throw Error("Payload body and response have different number of items")
    }
    parsedResponseItemsList.forEach((item, idx) => {
      let quantity = 1;
      try {
        quantity = parseInt(parsedPayloadBodyItemsList[idx].quantity, 10) || 1
      } catch (error) {
        if (console && console.warn) {
          console.warn(`[add-to-cart-tracker] Error in handleBulkItemCartAddResponse: ${error.message}`)
        }
      }
      handleItemAdded(item, quantity, requestPlacement, isGift)
    })
  }

  function parseSingleItemQuantity(body) {
    if (!body) {
      return 1
    }
    try {
      return JSON.parse(body).quantity || 1
    } catch (error) {
      if (body instanceof FormData) {
        if (body.has("quantity")) {
          return body.get("quantity")
        }
      } else {
        const vars = body.split("&");
        for (let i = 0; i < vars.length; i++) {
          const pair = vars[i].split("=");
          if (pair[0] === "quantity") {
            return pair[1]
          }
        }
      }
    }
    return 1
  }

  function parseRequestBody(body) {
    if (body instanceof FormData) {
      return parseFormData(body)
    } else {
      return JSON.parse(body)
    }
  }

  function parseFormData(formData) {
    const itemsMap = new Map;
    const nonIndexedKey = "nonIndexed";
    for (const entry of formData.entries()) {
      const key = entry[0];
      const value = entry[1];
      const match = key.match(/items\[(\d*)\]\[(\w+)\]/);
      if (!match) {
        continue
      }
      const index = match[1];
      const field = match[2];
      const itemKey = index === "" ? nonIndexedKey : index;
      const currentItem = itemsMap.get(itemKey) || {};
      currentItem[field] = value;
      itemsMap.set(itemKey, currentItem)
    }
    const uniqueItems = {};
    for (const entry of itemsMap.entries()) {
      const item = entry[1];
      if (!item.id) {
        continue
      }
      const existingItem = uniqueItems[item.id];
      if (existingItem) {
        existingItem.quantity = (parseInt(existingItem.quantity || "1", 10) + parseInt(item.quantity || "1", 10)).toString()
      } else {
        uniqueItems[item.id] = item
      }
    }
    return {
      items: Object.values(uniqueItems)
    }
  }

  function handleItemAdded(item, quantity, placement, isGift) {
    const stableID = localStorage.getItem('STATSIG_LOCAL_STORAGE_STABLE_ID');
    const properties = {
      placement: placement,
      variantId: String(item.id),
      productId: item.product_id,
      quantity: String(quantity ? quantity : 1),
      price: item.presentment_price,
      name: item.title,
      sku: item.sku,
      brand: item.vendor,
      variant: item.variant_title,
      category: item.product_type,
      isKit: placement === 'pdk' ? true : false,
      stableID: stableID,
      timestamp: Date.now()
    }

    const eventName = (() => {
      if (isGift) return 'sum_had_add_to_cart_gift'
      if (placement) {
        switch (placement) {
          case 'quick-add':
            return 'sum_had_add_to_cart_quickadd'
          case 'pdp':
          case 'pdk':
            return 'sum_had_add_to_cart_pdp'
          case 'cart-items':
            return 'sum_had_add_to_cart_minicart'
          case 'minicart_recommender':
            return 'sum_had_add_to_cart_minicart_recommender'
          default:
            return 'sum_had_add_to_cart_unknown'
        }
      }
    })()
    console.debug("%c [DEBUG][AddToCartTracker] event to gtag:", "color: green", eventName, properties);

    if (!window.gtag) return;
    if (!eventName) return;

    window.gtag('event', eventName, properties);
  }
})()